import _ from 'lodash';

import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";

import withStyles from "material-ui/styles/withStyles";

// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import Step1 from "./WizardSteps/Step1.jsx";
import Step2 from "./WizardSteps/Step2.jsx";
import Step3 from "./WizardSteps/Step3.jsx";
import Loading from "../../etc/Loading";
import CallFormReport from "./CallFormReport";
import CallFormServerCheck from "./CallFormServerCheck";
import CallFormSendReport from "./CallFormSendReport";
import CallFormQueue from "./CallFormQueue";
import Snackbar from "./CustomErrorSnackBar";

import {client} from "client";
import { getSpecificProject, getProject, managePin,
  createLog, createDevices, createCallReport,
  canReport, removePinQueue, createSpeakers } from "../graph";

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { COFFEE_SECRET_KEY } from 'constants/coffee';
import SingleLineCallFormServerCheck from "./SingleLineCallFormServerCheck";

const theme = createMuiTheme({
  overrides: {
    MuiFormLabel: { // Name of the component ⚛️ / style sheet
      root: { // Name of the rule
        color: 'black', // Some CSS
      },
    },
  },
});

class CallFormWizard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      doneLoading: false,
      showAlert: false,
      pinAlertTitle: "",
      pinAlertMessage: "",
      reportModalIsOpen: false,
      sendReportModalIsOpen: false,
      checkModalOpen: false,
      queueModalOpen: false,
      reportType: "fail",
      errorSnackbarOpen: false,
      formErrorMessage: "",
      snackBarType: "danger",
    };

    this.data = {};
    this.canReportCall = true;

    this.onUnload = this.onUnload.bind(this);
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.match.params)) {
      client.query({
        query: getSpecificProject,
        variables: ({projectId: this.props.match.params.id}),
        fetchPolicy: "network-only"
      }).then((data) => {
        const d = data.data.project;
        let config = (d.config=="") ? "{}" : d.config;
        this.data = {
          project: d,
          conf: JSON.parse(config),
          pid: this.props.match.params.id,
          collectionType: d.collectiontype,
        };

        if (d.collectiontype === 2) {
          this.data["receiver"] = {
            receiver_carrier: "",
            receiver_countrycode: "86",
            receiver_number: "12222",
            receiver_gender: "3",
            receiver_age: "22",
          };
        }

        if (d.collectiontype === 3) {
          this.data["receiver"] = {
            receiver_carrier: "",
            receiver_countrycode: "",
            receiver_number: "999999999",
            receiver_gender: "3",
            receiver_age: "33",
          };
        }

        this.setState({doneLoading: true});
      });
    }
    else {
      client.query({
        query: getProject,
        fetchPolicy: "network-only"
      }).then((data) => {
        const d = data.data.currentProject;

        this.data = {
          project: d,
          conf: JSON.parse(d.config),
          pid: d.pid,
          collectionType: d.collectiontype,
        };

        if (d.collectiontype === 2) {
          this.data["receiver"] = {
            receiver_carrier: "",
            receiver_countrycode: "86",
            receiver_number: "11111",
            receiver_gender: "3",
            receiver_age: "22",
          };
        }

        if (d.collectiontype === 3) {
          this.data["receiver"] = {
            receiver_carrier: "",
            receiver_countrycode: "",
            receiver_number: "999999999",
            receiver_gender: "3",
            receiver_age: "33",
          };
        }

        this.setState({doneLoading: true});
      });
    }

    window.addEventListener("beforeunload", this.onUnload);

    this.unlisten = this.props.history.listen((location, action) => {
      this.removePinQueue();
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onUnload);
    this.unlisten();
  }

  removePinQueue() {
    if (this.data['pin'] && this.data['pid']) {
      client.mutate({
        mutation: removePinQueue,
        variables: ({
          pin: this.data['pin'],
          pid: this.data['pid']
        }),
        fetchPolicy: "no-cache"
      }).then((data) => {});
    }
  }

  onUnload(event) {
    this.removePinQueue();
  }

  collectDataCallback(key, value) {
    this.data[key] = value;
  }

  getDataCallback(key) {
    return this.data[key];
  }

  getData() {
    return this.data;
  }

  showAlertCallback(stateObj) {
    this.setState(stateObj);
  }

  hidePinAlertModal() {
    this.setState({showAlert: false});
  }

  createDevices(pid, phonenumberInline, phonenumberOutline, countryCodeInline, countryCodeOutline) {
    return client.mutate({
      mutation: createDevices,
      variables: {
        pid: this.data['pid'],
        phonenumberInline: parseInt(this.data["caller"]["caller_number"]),
        phonenumberOutline: parseInt(this.data["receiver"]["receiver_number"]) || 0,
        countryCodeInline: this.data["caller"]["caller_countrycode"] || null,
        countryCodeOutline: this.data["receiver"]["receiver_countrycode"] || null,
        ageInline: this.data["caller"]["caller_age"] || 0,
        genderInline: this.data["caller"]["caller_gender"] || 0,
        regionInline: this.data["caller"]["caller_region"] || 0,
        ageOutline: this.data["receiver"]["receiver_age"] || 0,
        genderOutline: this.data["receiver"]["receiver_gender"] || 0,
        regionOutline: this.data["receiver"]["receiver_region"] || 0,
      }
    });
  }

  createSpeakers() {
    return client.mutate({
      mutation: createSpeakers,
      variables: {
        pid: this.data['pid'],
        phonenumberInline: parseInt(this.data["caller"]["caller_number"]),
        phonenumberOutline: parseInt(this.data["receiver"]["receiver_number"]) || 0,
        countryCodeInline: this.data["caller"]["caller_countrycode"] || null,
        countryCodeOutline: this.data["receiver"]["receiver_countrycode"] || null,
      }
    })
  }

  finishButtonClick(evt) {
    this.openSnackBar('Processing callform... Please Wait...', "info");

    setTimeout(() => {
      this.createSpeakers().then( (data) => {
        const resp1 = JSON.parse(data.data.createSpeakers.jsonObject);

        this.collectDataCallback('caller_speakerid', resp1.speaker_id1);
        this.collectDataCallback('caller_speakerpk', resp1.spkid1);

        this.collectDataCallback('receiver_speakerid', resp1.speaker_id2);
        this.collectDataCallback('receiver_speakerpk', resp1.spkid2);

        this.createDevices().then((data) => {
          const resp = JSON.parse(data.data.createDevices.jsonObject);

          this.collectDataCallback('caller_deviceid', resp.deviceId1);
          this.collectDataCallback('receiver_deviceid', resp.deviceId2);

          this.closeErrorSnackbar();
          this.setState({
            reportModalIsOpen: true
          });
        }).catch((data) => {
          this.openSnackBar('ERROR! -- Error generating device ids, please try again', "danger");
        });

      }).catch((data) => {
        this.openSnackBar('ERROR! -- Error generating speaker id, please try again', "danger");
      });
    }, 1000);
  }

  onNextButtonClick(currentStep) {
    let step = currentStep + 1;

    if (step === 1) {
      this.collectDataCallback("step2Next", 1);
    }

    if (step === 2) {
      this.collectDataCallback("step3Next", 1);
    }

  }

  onCallReportClose() {
    this.setState({
      reportModalIsOpen: false
    });
  }

  clearData() {
    this.collectDataCallback("clear3Data", 1);
    this.setState(this.state);
  }

  onReportModalCall() {
    client.mutate({
      mutation: managePin,
      variables: ({
        pin: this.data['pin'],
        uid: localStorage.getItem("APN_USERID"),
        pid: this.data['pid']
      }),
      fetchPolicy: "no-cache"
    }).then((data) => {
      this.checkQueue();
    }).catch((data) => {
      let errorData = data.graphQLErrors.map(x => x.message);

      if (errorData) {
        const errorMessage = JSON.parse(errorData[0]);
        let stateObj = {
          pinAlertTitle: errorMessage.message,
          showAlert: true,
        };

        if (errorMessage.pin_error_type === 1) {
          stateObj['pinAlertMessage'] = `${errorMessage.remaining_time} time remaining`;
        }

        this.setState(stateObj);
      }
    });

    this.onCallReportClose();
  }

  getPhoneNumber(data, type){
    const carrier = data[`${type}_carrier`] || "";
    const countryCode = data[`${type}_countrycode`] || "";
    const number = data[`${type}_number`] || "";

    return `${countryCode}${number}`
  }

  generateDemographic(data, order, type){
    const toSkip = [`${type}_carrier`, `${type}_countrycode`, `${type}_number`, `${type}_speakerid`];

    let finalString = "";
    for (let counter=0; counter < order.length; counter++) {
      let k = order[counter];

      if (order[counter]["key"])
        k = order[counter]["key"];

      if (!toSkip.includes(k))
        finalString += data[k].toString();
    }

    if (type === 'caller') {
      finalString += this.data['caller_speakerid'];
    }
    else {
      finalString += this.data['receiver_speakerid'];
    }

    return finalString
  }

  checkQueue() {
    this.setState({
      queueModalOpen: true
    });
  }

  saveCallToMonitor(cid, uid) {
    // fetch(`${process.env.REACT_APP_COFFEE_SERVER_URL}api/calls/started/`, {
    //   method: 'POST',
    //   headers: {
    //     'TP-Token': COFFEE_SECRET_KEY,
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     cid: cid,
    //     uid: uid,
    //   })
    // });
  }

  call() {
    let source = 0;
    let channel = "NOIDEAWHATTHISISHELP"; // LOL

    let caller_phone = this.getPhoneNumber(this.data["caller"], "caller");
    let receiver_phone = this.getPhoneNumber(this.data["receiver"], "receiver");
    let caller_demographic = this.generateDemographic(this.data["caller"], this.data["conf"]["ui:order"]["caller_props"]["ui:order"], "caller");
    let receiver_demographic = this.generateDemographic(this.data["receiver"], this.data["conf"]["ui:order"]["receiver_props"]["ui:order"], "receiver");;
    let caller_carrier = this.data["caller"]["caller_carrier"];
    let receiver_carrier = this.data["receiver"]["receiver_carrier"] || '';
    let that = this;

    let callerSpeakerID =  this.data['caller_speakerpk'];
    let rcverSpeakerID =  this.data['receiver_speakerpk'];

    client.mutate({
      mutation: createLog,
      variables: ({
        destination: that.data["project"]["extension"],
        channel: channel,
        src: source,
        spk1: caller_phone,
        spk2: receiver_phone || 0,
        demo1: caller_demographic,
        demo2: receiver_demographic,
        callerSpeakerid: callerSpeakerID,
        receiverSpeakerid: rcverSpeakerID,
        receiverDeviceid: this.data['receiver_deviceid'],
        callerDeviceid: this.data['caller_deviceid'],
        pin: that.data['pin'],
        pid: that.data['pid'],
        callerCarrier: caller_carrier,
        receiverCarrier: receiver_carrier
      }),
      fetchPolicy: "no-cache"
    }).then((data) => {
      const cid = data.data.createLogs.calls.cid;

      this.saveCallToMonitor(cid, localStorage.getItem("APN_USERID"));
      this.setState({checkModalOpen: true});
    });
  }

  serverCheckClose() {
    this.removePinQueue();

    this.setState({checkModalOpen: false});
  }

  onFormSendReportConfirm(description) {
    if (description === ""){
      console.log("invalid input");
      this.openSnackBar("Please tell us happened.");
    } else {
      client.mutate({
        mutation: createCallReport,
        variables: ({
          pin: this.data['pin'],
          uid: localStorage.getItem("APN_USERID"),
          pid: this.data['pid'],
          data: JSON.stringify(this.data),
          description: description,
          status: 1
        }),
        fetchPolicy: "no-cache"
      }).then((data) => {
        this.setState({
          pinAlertTitle: "",
          showAlert: true,
          pinAlertMessage: "Report sent!"
        });
      }).catch((data) => {
        let d = JSON.stringify(data);
        if (d.includes("3 reports per user per day"))
          this.setState({
            pinAlertTitle: "",
            showAlert: true,
            pinAlertMessage: "Report failed to send: Daily reports sent reached."
          });
        else
          this.setState({
            pinAlertTitle: "",
            showAlert: true,
            pinAlertMessage: "Report failed to send."
          });
      });

      this.setState({sendReportModalIsOpen: false});
      this.closeErrorSnackbar();
    }
  }

  onFormSendReportClose() {
    this.setState({sendReportModalIsOpen: false});
  }

  onCallFormQueueClose() {
    this.setState({queueModalOpen: false});
  }

  onCallFormQueueSuccess() {
    this.setState({
      queueModalOpen: false
    });

    this.call();
  }

  sendReportOpen(reportType) {
    client.mutate({
      mutation: canReport,
      variables: ({
        pin: this.data['pin'],
        pid: this.data['pid'],
        uid: localStorage.getItem("APN_USERID"),
      }),
      fetchPolicy: "no-cache"
    }).then((data) => {
      this.canReportCall = data.data.canReportCall.canReport;

      this.setState({sendReportModalIsOpen: true, reportType: reportType});
    });
  }

  openSnackBar(message, type){
    this.setState({
      errorSnackbarOpen: true,
      formErrorMessage: message,
      snackBarType: type || "danger"
    });
  }

  closeErrorSnackbar(){
    this.setState({
      errorSnackbarOpen: false,
    })
  }

  render() {
    const { doneLoading, showAlert,
      pinAlertTitle, pinAlertMessage, reportModalIsOpen,
      checkModalOpen, sendReportModalIsOpen, queueModalOpen } = this.state;
    let pinAlertModal = null;
    let reportModal = null;
    let checkModal = null;
    let sendReportModal = null;
    let queueModal = null;

    if (!doneLoading)
      return (<Loading />);
    else {
      if (!this.data.conf || this.data.conf===null || _.isEmpty(this.data.conf)) {
        return (<SweetAlert
            style={{ display: "block", marginTop: "-100px" }}
            title="Callform Error"
            showCancel={false}
            showConfirm={false}
            onConfirm={()=>{}}
        >
          Project Config not found. Please try again later or contact PE for more information.
        </SweetAlert>)
      }
    }



    if (showAlert) {
      pinAlertModal = (
          <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={pinAlertTitle}
              onConfirm={() => this.hidePinAlertModal()}
              onCancel={() => this.hidePinAlertModal()}
          >
            {pinAlertMessage}
          </SweetAlert>
      );
    }

    if (sendReportModalIsOpen) {
      sendReportModal = (<CallFormSendReport
          onFormSendReportClose={this.onFormSendReportClose.bind(this)}
          sendReportModalIsOpen={sendReportModalIsOpen}
          onFormSendReportConfirm={this.onFormSendReportConfirm.bind(this)}
          canReportCall={this.canReportCall}
          reportType={this.state.reportType}/>)
    }

    if (reportModalIsOpen) {
      reportModal = (<CallFormReport
          onCallReportClose={this.onCallReportClose.bind(this)}
          reportModalIsOpen={reportModalIsOpen}
          onReportModalCall={this.onReportModalCall.bind(this)}
          data={this.data} />);
    }

    if (queueModalOpen) {
      queueModal = (<CallFormQueue
          onCallFormQueueClose={this.onCallFormQueueClose.bind(this)}
          reportModalIsOpen={queueModalOpen}
          onCallFormQueueSuccess={this.onCallFormQueueSuccess.bind(this)}
          pin={this.data["pin"]}
          pid={this.data["pid"]}
      />);
    }

    if (checkModalOpen) {
      //checkModal = this.data.collectionType === 2 ?
      checkModal = [2, 3].includes(this.data.collectionType) ?
          (<SingleLineCallFormServerCheck onCallFormServerClose={()=>{}}
                                          checkModalIsOpen={checkModalOpen}
                                          serverCheckClose={this.serverCheckClose.bind(this)}
                                          sendReportOpen={this.sendReportOpen.bind(this)}
                                          clearData={this.clearData.bind(this)}
                                          pin={this.data["pin"]}
                                          pid={this.data["pid"]}
          />) : (
              <CallFormServerCheck onCallFormServerClose={()=>{}}
                                   checkModalIsOpen={checkModalOpen}
                                   serverCheckClose={this.serverCheckClose.bind(this)}
                  // inlineNumber={this.data["caller"]["caller_number"]}
                  // outlineNumber={this.data["receiver"]["receiver_number"]}
                                   sendReportOpen={this.sendReportOpen.bind(this)}
                                   clearData={this.clearData.bind(this)}
                                   pin={this.data["pin"]}
                                   pid={this.data["pid"]}
              />
          );
    }


    return (
        <MuiThemeProvider theme={theme}>
          <GridContainer justify="center">
            <ItemGrid xs={12} sm={8}>
              {
              [2, 3].includes(this.data.collectionType) ?  <Wizard
                    validate
                    steps={[
                      { stepName: "Pin", stepComponent: Step1, stepId: "pin",
                        props: this.props, data: this.data,
                        collectDataCallback: this.collectDataCallback.bind(this),
                        showAlertCallback: this.showAlertCallback.bind(this),
                        getDataCallback: this.getDataCallback.bind(this)},
                      { stepName: "Caller", stepComponent: Step2, stepId: "caller",
                        props: this.props, data: this.data,
                        collectDataCallback: this.collectDataCallback.bind(this),
                        showAlertCallback: this.showAlertCallback.bind(this),
                        getDataCallback: this.getDataCallback.bind(this)},
                    ]}
                    title="Callform"
                    subtitle="Setup your call"
                    finishButtonClick={this.finishButtonClick.bind(this)}
                    finishButtonText="Call"
                    onNextButtonClick={this.onNextButtonClick.bind(this)}
                /> : <Wizard
                    validate
                    steps={[
                      { stepName: "Pin", stepComponent: Step1, stepId: "pin",
                        props: this.props, data: this.data,
                        collectDataCallback: this.collectDataCallback.bind(this),
                        showAlertCallback: this.showAlertCallback.bind(this),
                        getDataCallback: this.getDataCallback.bind(this)},
                      { stepName: "Caller", stepComponent: Step2, stepId: "caller",
                        props: this.props, data: this.data,
                        collectDataCallback: this.collectDataCallback.bind(this),
                        showAlertCallback: this.showAlertCallback.bind(this),
                        getDataCallback: this.getDataCallback.bind(this)},
                      { stepName: "Receiver", stepComponent: Step3, stepId: "receiver",
                        props: this.props, data: this.data,
                        collectDataCallback: this.collectDataCallback.bind(this),
                        showAlertCallback: this.showAlertCallback.bind(this),
                        getDataCallback: this.getDataCallback.bind(this),
                        getData: this.getData.bind(this)},
                    ]}
                    title="Callform"
                    subtitle="Setup your call"
                    finishButtonClick={this.finishButtonClick.bind(this)}
                    finishButtonText="Call"
                    onNextButtonClick={this.onNextButtonClick.bind(this)}
                />
              }
            </ItemGrid>

            {pinAlertModal}
            {reportModal}
            {queueModal}
            {checkModal}
            {sendReportModal}

            <Snackbar
                formErrorMessage={this.state.formErrorMessage}
                errorSnackbarOpen={this.state.errorSnackbarOpen}
                closeErrorSnackbar={this.closeErrorSnackbar.bind(this)}
                snackBarType={this.state.snackBarType}
            />
          </GridContainer>
        </MuiThemeProvider>
    );
  }
}

export default withStyles(sweetAlertStyle)(CallFormWizard);



// WEBPACK FOOTER //
// ./src/views/callform/components/CallFormWizard.jsx